export class VerifyConstants {
  public static VERIFY = 'verify'
}
